import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  state: {
    controlValue: {
        showLayout: true,
        floatLayout: true,
        enableDownload: true,
        previewModal: true,
        paginateElementsByHeight: 11000,
        manualPagination: false,
        filename: 'Invoice',
        pdfQuality: 4,
        pdfFormat: 'a4',
        pdfOrientation: 'portrait',
        pdfContentWidth: '794px',
        minHeight:15,
        showZero: false,
    }
  },
  mutations: {
      updateField
  },
  
  getters: {
      getField
  },
})
